import {
  API_ENDPOINTS,
  apiRequest,
  DataReturnType,
  timeAsSeconds,
  Vehicle,
  VehicleOptions,
  AppError,
} from "@alba-cars/common-modules";
import QueryString from "qs";

interface SimilarCarsOptions extends VehicleOptions {
  priceRange?: number;
  limit?: number;
}

export class SimilarCarsParams {
  constructor(
    public priceRange: number = 5000,
    public limit: number = 4,
  ) {}

  static toPlain(options: Partial<SimilarCarsParams>): Record<string, any> {
    return {
      priceRange: options.priceRange,
      limit: options.limit,
    };
  }
}

export async function fetchSimilarCars(
  id: string,
  params?: Partial<SimilarCarsParams>,
  options?: Partial<SimilarCarsOptions>,
): Promise<Vehicle[] | null> {
  try {
    // Validate ID
    if (!id) {
      throw Error("Vehicle ID is required");
    }

    // Initialize options and parameters with defaults
    const searchParams = new SimilarCarsParams();
    const searchOptions = new VehicleOptions();

    // Merge provided params and options with defaults
    Object.assign(searchParams, params);
    Object.assign(searchOptions, options);

    // Build query string
    const query = QueryString.stringify(
      {
        ...SimilarCarsParams.toPlain(searchParams),
        options: VehicleOptions.toPlain(searchOptions),
      },
      {
        skipNulls: true,
        arrayFormat: "brackets",
      },
    );

    // 0381f33e-2815-4a31-9be6-1d95b715b020
    // Get endpoint
    // const endpoint = `${API_ENDPOINTS.vehicle.getSimilar(id)}${query ? `?${query}&makeId=213ec3e5-33ad-45c2-83d8-32ab0912909b` : "?makeId=213ec3e5-33ad-45c2-83d8-32ab0912909b"}`;
    const endpoint = `${API_ENDPOINTS.vehicle.getSimilar(id)}${query ? `?${query}` : ""}`;

    // Make API request
    const response = await apiRequest<DataReturnType<Vehicle[]>>(endpoint, {
      next: {
        tags: ["vehicle", `vehicle-${id}-similar`],
        revalidate: timeAsSeconds({ minutes: 30 }),
      },
    });

    // Return data or null if no data
    return response?.data ?? null;
  } catch (error) {
    // Log error for debugging
    console.error("Error fetching similar cars:", error);

    // Re-throw as AppError if it's not already
    if (!(error instanceof AppError)) {
      throw error;
    }
    throw error;
  }
}
